import { Skeleton } from "@mui/material";
import { useContext, useMemo } from "react";
import SharedTable, { TooltipCell } from "../components/shared-table";
import UploadStatus from "../enums/upload-status";
import { convertIntToString } from "../helpers/utils";
import { PermissionsContext } from "../permission-context";

const UploadHistoryTable = ({ data, tableName }) => {
  const { loading, error, hasPermission } = useContext(PermissionsContext);

  const columns = [
    {
      title: "Uploaded By",
      dataIndex: "uploadedBy",
      width: 150,
      sorter: (a, b) => a.uploadedBy?.localeCompare(b.uploadedBy),
    },
    {
      title: "Uploaded On",
      dataIndex: "uploadedOn",
      width: 200,
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.uploadedOn) - new Date(b.uploadedOn),
      render: (text) =>
        text
          ? new Date(text + "Z").toLocaleString("en-US", {
              timeZone: "America/Los_Angeles",
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "",
    },
    {
      title: "File Name",
      dataIndex: "fileName",
      width: 250,
      render: (text) => <TooltipCell text={text} width="250px" />,
    },
    {
      title: "Upload Status",
      dataIndex: "uploadStatus",
      width: 150,
      sorter: (a, b) => a.uploadStatus - b.uploadStatus,
      render: (status) => convertIntToString(status, UploadStatus),
    },
    {
      title: "Details",
      dataIndex: "uploadStatusDetails",
      width: 300,
      render: (text) => <TooltipCell text={text} width="300px" />,
    },
  ];

  // const getRowClassName = (record) => {
  //   if (record.uploadStatus === 0) return "row-red";
  //   if (record.uploadStatus === 2) return "row-orange";
  //   return "";
  // };
  const getRowClassName = (record) => {
    if (record.uploadStatusDetails === null) {
      return "row-red";
    }
    const details = (record.uploadStatusDetails ?? "").trim();
    if (/invalid data/i.test(details)) {
      return "row-red";
    }

    return "";
  };

  const dataWithKeys = useMemo(() => {
    return data?.map((item, index) => ({
      ...item,
      _uniqueKey: `${item.fileName}-${item.uploadedOn}-${index}`,
    }));
  }, [data]);

  return (
    <>
      {!loading && !error && hasPermission("PatientVisits") && (
        <div
          style={{ margin: "12px 0", fontFamily: "DM Sans", minHeight: "60vh" }}
        >
          {!data ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="60vh"
              sx={{ borderRadius: "15px" }}
              animation="wave"
            />
          ) : (
            <SharedTable
              columns={columns}
              dataSource={dataWithKeys}
              rowClassName={getRowClassName}
              rowKey="_uniqueKey"
              tableName={tableName}
              scroll={{ x: "max-content" }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default UploadHistoryTable;
